var React = require('react');

function Link (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"110","y":"88","width":"150","height":"24","fill":"#D8D8D8","key":1}),React.createElement("rect",{"x":"29","y":"110","width":"75","height":"2","fill":"#737373","key":2}),React.createElement("rect",{"x":"29","y":"88","width":"75","height":"20","fill":"#737373","key":3})]);
}

Link.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Link;

Link.default = Link;
